import * as types from './types';

const getFormValues = postingId => {
  return {
    type: types.GET_FORM_VALUES,
    meta: {
      async: true,
      blocking: false,
      api: 'publicadorProf',
      path: `/publication/api/v1/posting/STEP_DESCRIPTION/${postingId}`,
      method: 'GET'
    }
  };
};

const getSuggestedData = (postingId, siteId, resetSuggestedData) => {
  return !resetSuggestedData
    ? {
        type: types.GET_SUGGESTED_DATA,
        meta: {
          async: true,
          blocking: false,
          api: 'publicadorProf',
          path: '/publication/api/v1/suggester/generateData',
          method: 'GET',
          query: {
            postingId,
            siteId
          }
        }
      }
    : { type: types.RESET_SUGGESTED_DATA };
};

const resetSuggestedData = () => ({
  type: types.RESET_SUGGESTED_DATA
});

const updateFormValues = data => {
  return {
    type: types.SET_FORM_VALUES,
    payload: data
  };
};

const resetInfo = () => ({
  type: types.RESET_INFO
});

export { getFormValues, updateFormValues, getSuggestedData, resetInfo, resetSuggestedData };
